import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import DOMPurify from 'dompurify';
import { usePxToVw } from '../../../hooks/usePxToVw';

const AirtableButton = ({ text, settings, keyid = 0, onClick, disabled = false }) => {
  const { pxToVw } = usePxToVw();

  const [isHovered, setIsHovered] = useState(false);

  const angleInRadians = (settings?.shadow?.angle * Math.PI) / 180;
  const offsetX = Math.cos(angleInRadians) * settings?.shadow?.distance;
  const offsetY = Math.sin(angleInRadians) * settings?.shadow?.distance;

  const style = {
    // Dimensions and layout
    borderRadius: pxToVw(settings?.cornerRadius), // Rounded corners
    height: pxToVw(settings?.height), // Button height
    width: pxToVw(settings?.width), // Button width
    textAlign: settings?.textAlign, // Text alignment
    marginBottom: pxToVw(settings?.marginBottom),

    // Borders
    borderColor: isHovered ? settings?.highlight?.borderColor : settings?.outlineColor, // Border color
    borderWidth: settings?.outlineThickness + 'px', // Border thickness
    borderStyle: 'solid', // Always use solid border

    // Background and colors
    backgroundColor: isHovered ? settings?.highlight?.fillColor : settings?.fillColor, // Background color
    color: isHovered ? settings?.highlight?.fontColor : settings?.fontColor, // Font color
    fontFamily: settings?.font, // Font family
    fontSize: pxToVw(settings?.fontSize), // Font size

    // Box shadow
    boxShadow: `${offsetX}px ${offsetY}px ${settings?.shadow?.size}px rgba(
      ${parseInt(settings?.shadow?.color?.slice(1, 3), 16)},       
      ${parseInt(settings?.shadow?.color?.slice(3, 5), 16)},       
      ${parseInt(settings?.shadow?.color?.slice(5, 7), 16)},       
      ${settings?.shadow?.alpha}
    )`, // Dynamic shadow properties

    // Transition
    transition: '0.2s ease-in-out', // Smooth animation

    // Optional sound trigger (if you plan to include a custom sound on click)
    cursor: disabled ? 'not-allowed' : 'pointer', // Cursor style based on enabled state
    lineHeight: `${settings?.lineHeight}`,
    padding: `${pxToVw(settings?.padding)}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: disabled ? 0.2 : 1,
  };

  const playSound = () => {
    if (disabled) return;

    // const audioUrl = settings?.clickSound;
    // const volume = settings?.clickSoundVolume || 1;

    // if (audioUrl) {
    //   const audio = new Audio(audioUrl);
    //   audio.volume = volume || 1; // Set default volume if undefined
    //   audio.play().catch(error => console.error("Audio playback failed:", error));
    // }

    if (onClick) {
      onClick();
    }
  };

  const style2 = {
    backgroundImage: `url(${settings?.btnPng})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: `${pxToVw(settings?.height)}`, // Button height
    width: `${pxToVw(settings?.width)}`, // Button width
    marginBottom: pxToVw(settings?.marginBottom),
    cursor: disabled ? 'not-allowed' : 'pointer',
    backgroundColor: 'transparent', // Remove background color
    border: 'none', // Remove border
    outline: 'none', // Remove focus outline
    color: settings?.fontColor, // Font color
    fontFamily: settings?.font, // Font family
    fontSize: pxToVw(settings?.fontSize), // Font size
    opacity: disabled ? 0.2 : 1,
  };

  return (
    <>
      <button
        type="button"
        style={settings?.pngBtnenabled ? style2 : style}
        className={`${settings?.pngBtnenabled ? 'png-btn' : ''}`}
        onClick={playSound}
        onMouseOver={() => !disabled && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={disabled}
        data-tooltip-id={`tooltip-${keyid}`}
        data-tooltip-content={text?.length > 15 ? text : ''}
      >
        {settings?.hideBtnText ? (
          ''
        ) : (
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text || '') }} />
        )}
      </button>
      {text?.length > 15 && <Tooltip id={`tooltip-${keyid}`} />}
    </>
  );
};

export default AirtableButton;
